<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form class="modal-content" #f="ngForm" (ngSubmit)="f.valid && save(f)">
  <div class="modal-header">
    <h5
      class="modal-title"
      [xdaTranslate]="
        saveAsNew ? 'SDE_SAVE_NEW_WORKFLOW' : 'SDE_SAVE_WORKFLOW'
      "></h5>
  </div>

  <div class="modal-body pb-2" tabindex="-1">
    @if (!saveAsNew) {
      <div class="form-group">
        <xrx-radio
          id="radio"
          [list]="saves"
          property="value"
          localize="SDE_KEY"
          [(checkedItem)]="selectedSave"></xrx-radio>
      </div>
    }

    <div class="form-group">
      <xrx-input
        type="text"
        id="name"
        name="name"
        [(ngModel)]="name"
        placeholder="SDE_ENTER_NAME_WORKFLOW"
        [required]="true"
        [readonly]="selectedSave.value && !saveAsNew"
        label="SDE_NAME3"
        error="{{ error }}"></xrx-input>
    </div>

    @if (allowSharing) {
      <div class="form-group">
        <xrx-checkbox
          label="SDE_MAKE_PUBLIC_WORKFLOW"
          [(checkBoxValue)]="public"
          name="private"
          (toggle)="privateToggle($event, f)"></xrx-checkbox>
      </div>
    }

    <div class="form-group">
      <label xdaTranslate>SDE_WORKFLOW_ICON</label>
      <xrx-radio
        id="radio"
        [list]="options"
        property="value"
        localize="SDE_KEY"
        [(checkedItem)]="selected"></xrx-radio>
    </div>

    <xrx-icon-picker
      [(icon)]="icon"
      [(showDefault)]="selected.value"></xrx-icon-picker>
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" xdaTranslate>SDE_CANCEL</span>
      </button>
    </div>
    <div class="cb">
      <button type="submit" class="xrx-btn btn-primary">
        <span class="btn-label" xdaTranslate>SDE_SAVE</span>
      </button>
    </div>
  </div>
</form>
